import { render, staticRenderFns } from "./CustomerDeliveryAddressEdit.vue?vue&type=template&id=5893ded8&scoped=true"
import script from "./CustomerDeliveryAddressEdit.vue?vue&type=script&lang=js"
export * from "./CustomerDeliveryAddressEdit.vue?vue&type=script&lang=js"
import style0 from "./CustomerDeliveryAddressEdit.vue?vue&type=style&index=0&id=5893ded8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5893ded8",
  null
  
)

export default component.exports